import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import InviteUserForm from '../../components/users/InviteUserForm';
import { useAuth0 } from '@auth0/auth0-react';
import { getUsersRoles, isSuperAdmin, isAdmin } from '../../utils/getUsersRoles';
import { Navigate } from 'react-router-dom';

const InviteUserPage: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();
  // We don't need to track roles separately since we're using isSuperAdminUser and isAdminUser
  const [loading, setLoading] = React.useState(true);
  const [isSuperAdminUser, setIsSuperAdminUser] = React.useState(false);
  const [isAdminUser, setIsAdminUser] = React.useState(false);

  React.useEffect(() => {
    const checkUserRole = async () => {
      if (isAuthenticated && user) {
        try {
          const userRoles = await getUsersRoles(user);
          setIsSuperAdminUser(isSuperAdmin(userRoles));
          setIsAdminUser(isAdmin(userRoles));
        } catch (error) {
          console.error('Error fetching user roles:', error);
        } finally {
          setLoading(false);
        }
      } else if (!isLoading) {
        setLoading(false);
      }
    };

    checkUserRole();
  }, [isAuthenticated, isLoading, user]);

  // Show loading state
  if (isLoading || loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <p>Loading...</p>
      </Box>
    );
  }

  // Redirect if not authenticated or not a superadmin/admin
  if (!isAuthenticated || (!isSuperAdminUser && !isAdminUser)) {
    return <Navigate to="/unauthorized" />;
  }

  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <InviteUserForm />
      </Paper>
    </Container>
  );
};

export default InviteUserPage;